import axios from 'axios';

// --- PRODUCTION CONFIGURATION ---
// REPLACE 'api.yourdomain.com' with your actual domain or subdomain.
// Ensure you keep the '/api/' at the end.
const API_URL = 'https://revenuesetters.com/api/'; 

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Security Interceptor: Attaches Token automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;